import { createAction, props } from '@ngrx/store';
import {createActionWithCorrelation} from '@kion/ngrx-helper';
import {Auth} from '@kion/data-models';

export const loadAllSuccess = createActionWithCorrelation(
  "[Auth] loadAll Success",
  props<{ auths: Auth[] }>()
);
export const loadAllError = createActionWithCorrelation(
  "[Auth] loadAll Error",
  props<{error: any}>()
);
export const loadAll = createActionWithCorrelation(
  "[Auth] loadAll",
  loadAllSuccess.type,
  loadAllError.type
);

export const clientAuthSuccess = createActionWithCorrelation(
  "[Auth] client auth success",
  props<{ auth: Partial<Auth> }>()
);
export const clientAuthError = createActionWithCorrelation(
  "[Auth] client auth error",
  props<{ error: any }>()
);
export const clientAuth = createActionWithCorrelation(
  "[Auth] client auth",
  clientAuthSuccess.type,
  clientAuthError.type
);

export const userAuthSuccess = createActionWithCorrelation(
  "[Auth] user auth success",
  props<{ auth: Partial<Auth> }>()
);
export const userAuthError = createActionWithCorrelation(
  "[Auth] user auth error",
  props<{ error: any }>()
);
export const userAuth = createActionWithCorrelation(
  "[Auth] user auth",
  props<{ userName: string, idToken: string, accessToken: string, idp: string, oid: string  }>(),
  userAuthSuccess.type,
  userAuthError.type
);
export const userAuthGlobal = createActionWithCorrelation(
  "[Auth] user auth global",
  props<{ userName: string, idToken: string, accessToken: string, idp: string, oid: string, unitNumber: string, hash: string, isGSMi: string, GSMiSite: string , dematicPunchOutKey: string, dematicPunchOutSid: string }>(),
  userAuthSuccess.type,
  userAuthError.type
);

export const checkWhoAmISuccess = createActionWithCorrelation(
  "[Auth] check who am i success",
  props<{ check: any }>()
);
export const checkWhoAmIError = createActionWithCorrelation(
  "[Auth] check who am i error",
  props<{ error: any }>()
);
export const checkWhoAmI = createActionWithCorrelation(
  "[Auth] check who am i",
  props<{ accessToken: string }>(),
  checkWhoAmISuccess.type,
  checkWhoAmIError.type,
);

export const refreshUserTokenSuccess = createActionWithCorrelation(
  "[Auth] refresh user token success",
  props<{ auth: Partial<Auth>}>()
);
export const refreshUserTokenError = createActionWithCorrelation(
  "[Auth] refresh user token error",
  props<{ error: any }>()
);
export const refreshUserToken = createActionWithCorrelation(
  "[Auth] refresh user token",
  props<{ token: string }>(),
  refreshUserTokenSuccess.type,
  refreshUserTokenError.type
);

export const deleteUserTokenSuccess = createActionWithCorrelation(
    "[Auth] delete user token success"
);

export const deleteUserTokenError = createActionWithCorrelation(
    "[Auth] delete user token error"
);

export const deleteUserToken = createActionWithCorrelation(
    "[Auth] delete user token",
    deleteUserTokenSuccess.type,
    deleteUserTokenError.type
);

export const clearAuthSuccess = createActionWithCorrelation(
  "[Auth] clear Auth Success"
);
export const clearAuthError = createActionWithCorrelation(
  "[Auth] clear Auth Error"
);
export const clearAuth = createActionWithCorrelation(
  "[Auth] clear Auth",
  clearAuthSuccess.type,
  clearAuthError.type
);

